const sizes = {
    1: {
        mobile: '720 x 340',
        desktop: '1330 x 386',
    },
    2: {
        mobile: '640 x 235',
        desktop: '640 x 235',
    },
    3: {
        mobile: '640 x 235',
        desktop: '640 x 235',
    },
    4: {
        mobile: '720 x 340',
        desktop: '1330 x 386',
    },
    5: {
        mobile: '400 x 400',
        desktop: '400 x 400',
    },
};

export default sizes;



// WEBPACK FOOTER //
// ./src/modules/BannerPlace/sizes.ts